module.exports = __webpack_public_path__ + "static/media/bus-side.253ee1fa.svg";